import React, { Children } from "react";
import { Tabs as TabStyled, TabsContainer } from "./styles";

export const Tabs = ({ children, hideIndicator, indicatorColor, classes, ...props }) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const a11yProps = (index) => {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  };

  const childrenWithProps = Children.map(children, (Child, index) => {
    if (React.isValidElement(Child)) {
      return React.cloneElement(Child, {
        disableRipple: true,
        ...a11yProps(index),
      });
    }
    return Child;
  });

  return (
    <TabsContainer>
      <TabStyled
        value={value}
        onChange={handleChange}
        indicatorColor={indicatorColor}
        classes={classes}
        TabIndicatorProps={{
          style: { display: hideIndicator ? "none" : "" },
          children: <span />,
        }}
        {...props}
      >
        {childrenWithProps}
      </TabStyled>
    </TabsContainer>
  );
};
